import {  FormControlLabel, makeStyles, Radio, RadioGroup } from '@material-ui/core';
import { connect } from 'react-redux';
import React from 'react';
import { Typography } from '@material-ui/core';
import { TermsConditionsLink } from '../../Shared/Constants';
import Coupon from './Coupon';
import { verifyCouponApplication } from '../Subscription/SubscriptionServices';
import { couponDetailsCaptured, couponDetailsReset } from '../../Actions/CustomerDetailsActions';
import { useState, useEffect } from 'react';
import { PartnerDetails } from '../../Constants/PartnerDetails';

const useStyles = makeStyles(() => ({
    root: {
        width: '384px',
        backgroundColor: '#1C1C1C',
        padding: '23px',
        textAlign: 'left',
        marginBottom: '80px'
    },
    rootMobile: {
        width: 'auto',
        backgroundColor: '#1C1C1C',
        padding: '23px',
        textAlign: 'left',
        marginBottom: '80px'
    },
    productContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: '40px'
    },
    couponContainer: {
        marginBottom: '40px',
        display: 'flex',
        justifyContent: 'space-between',
    },
    totalContainer: {
        borderTop: '1px solid #ffffff99', 
        marginTop: 8,
        paddingTop: 16,
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: '33px',
    }, 
    notesContainer: {
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: '1em',
        marginBottom: '7px', 
        color: 'rgb(176, 176, 176)'
    },
    productInstalment: {
        display: 'flex',
        flexDirection: 'column',
        gap: 10
    },
    instalmentOption: {
        display: 'flex',
        gap: 10,
        paddingTop: 5,
    }
}));

const PaymentSummary = (props) => {
    const classes = useStyles();
    const [errorMessage, setErrorMessage] = useState('');
    const [amountOff, setAmountOff] = useState('');
    const [selectedPriceId, setSelectedPriceId] = useState('');
    const [totalPrice, setTotalPrice] = useState(0);
    const [discountValue, setDisountValue] = useState(0);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    const handleWindowSizeChange = () =>  {
        setIsMobile(window.innerWidth <= 768);
    };

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        };
    }, []);
    
    useEffect(() => {
        if(props?.values?.coupon === ''){
            couponProcess(props?.values);
        } else {
            setAmountOff('');
        }
    }, [props?.values?.coupon]);

    useEffect(() =>{
        if (props.subscription) {
            setSelectedPriceId(props.subscription.priceId);
        }
    }, [props.subscription]);

    useEffect(() => {
        if (selectedPriceId?.length > 0) {
            let price = 0;
            if (selectedPriceId === props.subscription.priceId) {
                price = props.subscription.initialChargeAmount;
            } else if (selectedPriceId === props.subscription.instalmentPriceId) {
                price = props.subscription.instalmentAmount * props.subscription.numberOfInstalment;
            }

            if (props.couponDetails && props.couponDetails.isValid && props.couponDetails.products.length > 0) {
                const applicableProduct =props.couponDetails.products[0];
                if (applicableProduct.duration === 'once') {
                    let discountedValue = (selectedPriceId === props.subscription.priceId) ? props.subscription.initialChargeAmount : props.subscription.instalmentAmount;
                    if (applicableProduct.percentOff !== null) {
                        setAmountOff(`${applicableProduct.percentOff}%`);
                        discountedValue = (discountedValue * applicableProduct.percentOff / 100);
                    } else if (applicableProduct.amountOff !== null) {
                        setAmountOff(`$${applicableProduct.amountOff}`);
                        discountedValue = applicableProduct.amountOff;
                    }
                    price -= discountedValue;
                    setDisountValue(discountedValue);
                } else {
                    let discountedValue = (selectedPriceId === props.subscription.priceId) ? props.subscription.initialChargeAmount : (props.subscription.instalmentAmount * props.subscription.numberOfInstalment);
                    if (applicableProduct.percentOff !== null) {
                        setAmountOff(`${applicableProduct.percentOff}%`);
                        discountedValue = (discountedValue * applicableProduct.percentOff / 100);
                    } else if (applicableProduct.amountOff !== null) {
                        const numberOfPayment = (selectedPriceId === props.subscription.priceId) ? 1 : props.subscription.numberOfInstalment;
                        const amountOff = applicableProduct.amountOff * numberOfPayment;
                        setAmountOff(`$${amountOff}`);
                        discountedValue = amountOff;
                    }
                    price -= discountedValue;
                    setDisountValue(discountedValue);    
                }
            } else {
                setAmountOff('');
                setDisountValue(0);
            }
            props.setFieldValue('priceId', selectedPriceId);
            props.setFieldValue('price', price);
            if (props.onPriceChange)
                props.onPriceChange(price);
            setTotalPrice(price);
        }
    }, [selectedPriceId, props.couponDetails]);

    useEffect(() => {
        props.setFieldValue('discountValue', discountValue);
    }, [discountValue]);


    const couponProcess = async (values) => {
        if (values?.coupon !== '') {
            let data = await verifyCouponApplication(values?.coupon, props.subscription.crmProductCode, selectedPriceId);
            if (data?.isValid) {
                props.dispatch(couponDetailsCaptured({ ...data, promoCode: values?.coupon }));
                props.setFieldValue('couponValid', data.isValid);
                setErrorMessage('');
            } else {
                props.setFieldValue('couponValid', false);
                setErrorMessage('Invalid coupon');
            }
        } else {
            props.setFieldValue('couponValid', false);
            setErrorMessage('');
        }
    };

    const clearCoupon = () => {
        props.setFieldValue('couponValid', false);
        props.setFieldValue('coupon', '');
        props.dispatch(couponDetailsReset());
    };
    
    const getAdditionalTermsAndConditions = (terms) => {
        switch(terms) {
            case 'AIA':
                return <><br></br>*Eligible AIA Health members pay ${props.subscription?.initialChargeAmount} out of pocket – AIA Health will cover the rest: if you have physiotherapy
included in your extras cover, you have served relevant waiting period, and have at least ${props.subscription?.rrpPrice} remaining on your physiotherapy cover limits. If you have less than ${props.subscription?.rrpPrice} remaining under your
physiotherapy cover limits AIA Health will contribute an amount equal to your remaining
physiotherapy limit. You will need to pay the remaining out of pocket balance.</>;
            default:
                return null;
        }
    };

    return (
        <div id="payment-summary" className={isMobile ? classes.rootMobile : classes.root}>
            <Typography variant='h2'>Summary</Typography>
            {
                (props.subscription.instalmentPriceId?.length > 0 && props.subscription.numberOfInstalment > 0) ?
                    <>
                        <div className={classes.productInstalment}>
                            <div>
                                <Typography>{props.subscription.name}</Typography>
                                <Typography variant='body2' color='textSecondary'>
                                    {`${props.subscription.subscriptionInterval} ${props.subscription.subscriptionIntervalUnit}${props.subscription.subscriptionInterval > 1 ? 's': ''}`}                      
                                </Typography>
                            </div>
                            <div>
                            
                                <Typography id="payment-method-label">Payment options:</Typography>
                                <RadioGroup
                                    aria-labelledby="payment-method-label"
                                    value={selectedPriceId}
                                    onChange={(event) => setSelectedPriceId(event.target.value) }>
                                    <FormControlLabel value={props.subscription.priceId} control={<Radio />} label={`$ ${props.subscription.initialChargeAmount} up-front`} />
                                    <FormControlLabel value={props.subscription.instalmentPriceId} control={<Radio />} label={`${props.subscription.numberOfInstalment} payments x $${props.subscription.instalmentAmount} ${props.subscription.instalmentUnit.includes('every') ? props.subscription.instalmentUnit : 'every ' + props.subscription.instalmentUnit}`} />
                                </RadioGroup>
                            </div>
                        </div>
                        <Coupon
                            value={props.values?.coupon}
                            setFieldValue={props.setFieldValue}
                            onClick={() => couponProcess(props.values) }
                            errorMessage={errorMessage}
                            discountAmount={amountOff}
                            onClearCode={clearCoupon}
                        />

                        <div className={classes.totalContainer}>
                            <Typography>Total {amountOff.length > 0 ? `(with ${amountOff} off applied)` : ''}</Typography>
                            <Typography>$ {totalPrice}</Typography>                          
                        </div>
                        <div className={classes.notesContainer}>
                            Payment <a href={TermsConditionsLink} target='_blank' rel='noopener noreferrer' className={'TermsAndConditionsLink'}>terms & conditions</a>
                        </div>
                    </>
                    :
                    <>
                        <div className={classes.productContainer}>
                            <div>
                                <Typography style={{maxWidth: '80%'}}>{props.subscription.name}</Typography>
                                {
                                    props.subscription.overridePaymentSubscriptionInfo && props.subscription.overridePaymentSubscriptionInfo === PartnerDetails.AIA.name ? 
                                        <Typography variant='body2' color='textSecondary' style={{lineHeight: '20px'}}>
                                            Covered by AIA Health* `${props.subscription?.rrpPrice}`<br/>Out of pocket `${props.subscription?.initialChargeAmount}`
                                        </Typography> :
                                        <Typography variant='body2' color='textSecondary'>
                                            {`${props.subscription.subscriptionInterval}  ${props.subscription.subscriptionIntervalUnit}${props.subscription.subscriptionInterval > 1 ? 's': ''}`}                      
                                        </Typography>
                                }                            
                                {
                                    props.subscription.appointmentAllowance > 0 ??
                            <Typography variant='body2' color='textSecondary'>
                                {`Include ${props.subscription.appointmentAllowance}x online physio`} {props.subscription.appointmentAllowance > 1 ? 'appointments' : 'appointment'}
                                <br />{'& access to Universal Practice app.'}
                            </Typography>
                                }
                            </div>
                            {
                                props.subscription.rrpPrice > 0 ? (
                                    <Typography>
                                        {`$${props.subscription.initialChargeAmount} (RRP $${props.subscription.rrpPrice})`}
                                    </Typography>
                                ) : (
                                    <Typography>
                                        {`$${props.subscription.initialChargeAmount}`}
                                    </Typography>
                                )
                            }
                        </div>
                        { props.subscription.initialChargeAmount > 0 && props.subscription.paymentIsManual === false &&
                            <Coupon
                                value={props.values?.coupon}
                                setFieldValue={props.setFieldValue}
                                onClick={() => couponProcess(props.values) }
                                errorMessage={errorMessage}
                                discountAmount={amountOff}
                                onClearCode={clearCoupon}
                            />
                        }
                        <div className={classes.totalContainer}>
                            <Typography>Total {amountOff.length > 0 ? `(with ${amountOff} off applied)` : ''}</Typography>
                            {
                                props.subscription.rrpPrice > 0 ? (
                                    <Typography>
                                        {`$${totalPrice} (RRP $${props.subscription.rrpPrice})`}
                                    </Typography>
                                ) : (
                                    <Typography>${totalPrice}</Typography>  
                                )
                            }                                                    
                        </div>
                        <div className={classes.notesContainer}>
                            { 
                                ( props.subscription.initialChargeAmount > 0 && props.subscription.paymentIsManual === false) ?
                                    <>
                                Payment <a href={TermsConditionsLink} target='_blank' rel='noopener noreferrer' className={'TermsAndConditionsLink'}>terms & conditions</a>
                                    </>
                                    :
                                    <a href={TermsConditionsLink} target='_blank' rel='noopener noreferrer' className={'TermsAndConditionsLink'}>Terms & Conditions</a>
                            }
                            <br />
                            {getAdditionalTermsAndConditions(props.subscription.paymentAdditionalTermsAndConditions)}
                        </div>
                    </>
            }
          
         
        </div>
    );
};

function mapStateToProps(state) {
    return {
        subscription: state.customerDetails.subscription,
        couponDetails: state.customerDetails.couponDetails 
    };
}

export default connect(mapStateToProps)(PaymentSummary);